module.exports = __webpack_public_path__ + "static/media/qnap.plans.6d353b6f.png";